import React from 'react';

import { formatAmount, fractionToPercent } from 'helpers/helpers';
import Grid from '@material-ui/core/Grid';
import H2 from 'apps/Pdf/components/common/H2';

import useGeneralStyles from 'apps/Pdf/styles/general';
import { FeesEffectData } from '../StatementInterface';
import { Currency } from 'enums';

interface Props {
  data: FeesEffectData;
  currency: Currency;
}

const FeesEffect = (props: Props) => {
  const styles = useGeneralStyles();
  const { data, currency } = props;

  return (
    <Grid container className={`${styles.lines} ${styles.avoidPageBreak}`}>
      <H2>Poplatky a jejich vliv na výkonnost portfolia</H2>
      <Grid item xs={8}>
        Průměrná hodnota majetku na účtu během kalendářního roku:
      </Grid>
      <Grid item xs={4} className={`${styles.value} ${styles.right}`}>
        {data.avgAnnualAum && data.avgAnnualAum.value !== null
          ? formatAmount(data.avgAnnualAum, currency)
          : ''}
      </Grid>
      <Grid item xs={8}>
        Naúčtované pravidelné poplatky celkem:
      </Grid>
      <Grid item xs={4} className={`${styles.value} ${styles.right}`}>
        {data.regularFeesTotal && data.regularFeesTotal.value !== null
          ? formatAmount(data.regularFeesTotal, currency)
          : ''}
      </Grid>
      <Grid item xs={8}>
        Efekt pravidelných poplatků na výkonnost portfolia:
      </Grid>
      <Grid item xs={4} className={`${styles.value} ${styles.right}`}>
        {data.regularFeesEffect !== null ? fractionToPercent(data.regularFeesEffect) : ''}
      </Grid>
      <Grid item xs={8}>
        Naúčtované vstupní poplatky:
      </Grid>
      <Grid item xs={4} className={`${styles.value} ${styles.right}`}>
        {data.entryFees && data.entryFees.value !== null
          ? formatAmount(data.entryFees, currency)
          : ''}
      </Grid>
      <Grid item xs={8}>
        Vyplacené pobídky IZ (z uvedených poplatků):
      </Grid>
      <Grid item xs={4} className={`${styles.value} ${styles.right}`}>
        {data.commission && data.commission.value !== null
          ? formatAmount(data.commission, currency)
          : ''}
      </Grid>
    </Grid>
  );
};

export default FeesEffect;
